const awsmobile = {
  aws_project_region: "us-east-1",
  aws_cognito_region: "us-east-1",
  aws_cognito_identity_pool_id: "us-east-1:85cdfe51-923d-45b8-9708-ec1f1a17c0e9",
  aws_user_pools_id: "us-east-1_jHGHyDUh6",
  aws_user_pools_web_client_id: "3990klniilfkfjlfghicf4gvs6",
  oauth: {
    domain: "prod-team-team.auth.us-east-1.amazoncognito.com",
    scope: ["email", "openid", "profile", "aws.cognito.signin.user.admin"],
    redirectSignIn: "https://team.dev.gothamsports.com/",
    redirectSignOut: "https://team.dev.gothamsports.com/",
    responseType: "code",
  },
  federationTarget: "COGNITO_USER_POOLS",
  aws_appsync_graphqlEndpoint: "https://dgdlfh3ayzfbdfmwpdmekusoru.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_region: "us-east-1",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
};

export default awsmobile;